import type { FaireProductEntity } from "../../entity_types/product";

export const p_99yn6ccakm: FaireProductEntity = {
  token: "p_99yn6ccakm",
  type: "product",
  name: "Vera Fairisle Sweater - Moonstone",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/f25b10161d8c575f477f6ab3fa55076795aa258e278f5e6e265d969f4cbccb2c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/11b02c01368d4d07e204c6c34cb7149d5e5c08db00a12ceb6ffe207e46dd926b.jpeg",
    "https://cdn.faire.com/fastly/76c31047d5201dc5c75dc690356862e77394d8f2397fea00d169c4dace4782aa.jpeg",
    "https://cdn.faire.com/fastly/d24f235ff4732fd9cedba41c39934895dbbfa767e906ea71a632b7415911f79d.jpeg",
    "https://cdn.faire.com/fastly/8fb78a89c7e3d23dd9f680f1383bb96dc51d951a44eb4864fc07fcae401bd4cb.jpeg",
    "https://cdn.faire.com/fastly/f3f2070b7ee1eb1cc27620e57451310e379c47b6f87378a78be864429ebf48ee.jpeg",
    "https://cdn.faire.com/fastly/9a0b1d54205938fde6a2a48a3a2a1d92c50f9f04fd4d2dbf93384cadb933d6b4.jpeg",
    "https://cdn.faire.com/fastly/80a9d0ecacf52241fba4d2218fa1ceccd2f7b15c856f612913c5529fa5b6a2f9.jpeg",
    "https://cdn.faire.com/fastly/a3679165bd27fb1b06ce8bcb925a8a0e4577f47acdc71317f2cf093ee33cf9cc.jpeg",
    "https://cdn.faire.com/fastly/7a69378006957337999b1628f9f9d6047a76016b9a9dd15f66cf312efc9d75f3.jpeg",
    "https://cdn.faire.com/fastly/0c4faaf83fc765092ec280412074aa02862ec857327550b5bf724f2f40a9e05a.jpeg",
    "https://cdn.faire.com/fastly/272d0b90a99b10498874fd4cdffb6103cceeb0aa8c9007e7f874f1ebc82b80c6.jpeg"
  ],
  priceDollars: 116.1,
  description: "A modern nod to a timeless knit tradition. The Vera Fairisle Sweater reimagines a classic motif through graphic patternwork meets ultra-soft alpaca warmth.\n\n• 89% Alpaca 11% Polyamide\n• Artisan made in Peru with Fair Trade practices to maintain ethical and responsible integrity\n• Classic fit with a subtle crop",
  tags: [],
  msrpDollars: 258,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:27.442Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
